import { render } from "./bets.vue?vue&type=template&id=3c7b817c"
import script from "./bets.vue?vue&type=script&lang=js"
export * from "./bets.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__